import { render } from "./FormSelect.vue?vue&type=template&id=4d1c5776"
import script from "./FormSelect.vue?vue&type=script&lang=js"
export * from "./FormSelect.vue?vue&type=script&lang=js"
script.render = render

export default script